import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { MeasureJson } from '@/types/domain/measure/entities/measureEntity';

import { measureSlice } from '@/domain/measure/redux';
import { service } from '@/share';

export const refreshMeasureList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'measure/refreshMeasureList',
  async (_, thunkApi) => {
    const result = await service.measure.getMeasureList(null);
    thunkApi.dispatch(measureSlice.actions.setMeasureList(result));
  },
);

export const getMeasureList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'measure/getMeasureList',
  async (_, thunkApi) => {
    const { nextToken, measureList } = thunkApi.getState().measure;
    const result = await service.measure.getMeasureList(nextToken);
    const newList = measureList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(measureSlice.actions.setMeasureList({
      items: newList,
      nextToken: result.nextToken,
    }));
  },
);

export const createMeasure = createAsyncThunk<
  void,
  MeasureJson,
  ThunkApiType
>(
  'measure/create',
  async (input, _thunkApi) => {
    await service.measure.createMeasure(input);
    await service.measureNursery.sendNurseryMeasure(input);
  },
);

export const updateMeasure = createAsyncThunk<
  void,
  MeasureJson,
  ThunkApiType
>(
  'measure/update',
  async (input, _thunkApi) => {
    await service.measure.updateMeasure(input);
    await service.measureNursery.sendNurseryMeasure(input);
  },
);

export const deleteMeasure = createAsyncThunk<
  void,
  MeasureJson,
  ThunkApiType
>(
  'measure/delete',
  async (input, _thunkApi) => {
    await service.measure.deleteMeasure(input);
    await service.measureNursery.removeNurseryMeasure(input);
  },
);
